import {
  STATS_TOTALS,
  STATS_BRANDS,
  STATS_REPLENISH,
  STATS_BRANDS_LOADING,
  SET_CURRENT_FILTER_RANGE,
} from '../constants/statsTypes';
import { ROLES_CURRENT_ROLE } from '../constants/rolesTypes';

const initialState = {
  brands: [],
  replenish: [],
  totalIncome: 0,
  totalItems: 0,
  totalOrders: 0,
  isLoading: false,
  filterRange: {
    start: new Date(),
    end: new Date(),
  },
};

const stats = (state = initialState, action) => {
  const end = new Date();
  const currenMonth = end.getMonth();
  let start = new Date();
  start.setMonth(currenMonth - 1);

  switch (action.type) {
    case ROLES_CURRENT_ROLE:
      return {
        ...state,
        filterRange: { start, end },
      };
    case SET_CURRENT_FILTER_RANGE:
      return {
        ...state,
        filterRange: action.payload,
      };
    case STATS_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case STATS_REPLENISH:
      return {
        ...state,
        replenish: action.payload,
      };
    case STATS_TOTALS:
      return {
        ...state,
        totalIncome: action.payload.totalIncome,
        totalItems: action.payload.totalItems,
        totalOrders: action.payload.totalOrders,
      };
    case STATS_BRANDS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      break;
  }
  return state;
};

export default stats;
